import React from "react";
import { mergeStyles } from "@fluentui/merge-styles";
import { useMount } from "react-use";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import {
  InfoRegular,
} from "@fluentui/react-icons";
import { emptyClasses, infoClass} from "./styles";

const EmptyAttachments = () => {
  const appInsights = useAppInsightsContext();

  useMount(() => {
    appInsights.trackPageView({ name: "No email attachments" });
  });

  return (
    <div className={emptyClasses}>
      <InfoRegular className={infoClass} />
      Use the menu to pause your inbox and summarise or follow threads
    </div>
  );
};

export default EmptyAttachments;
